module.exports = __webpack_public_path__ + "media/images/gn_icon03_on-20175a19c79f1b5c17f2008fa46495b0.png";